import React from "react";
import { insuranceTypes } from "../data";

function Insurance() {
  return (
    <section className="section">
      <div className="section-header">
        <span className="section-kicker">Insurance & Protection</span>
        <h2 className="section-title">
          Cover for you and the people who rely on you
        </h2>
        <p className="section-subtitle">
          Borrowing well is one half of it. The other half is making sure an
          illness or an injury does not undo years of work. We put that cover in
          place alongside the lending.
        </p>
      </div>

      <div className="card-grid" style={{ marginBottom: "24px" }}>
        {insuranceTypes.map((ins) => (
          <div className="card" key={ins.title}>
            <div className="card-title">{ins.title}</div>
            <div className="card-text">{ins.description}</div>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-title">How we work with insurers</div>
        <p className="card-text">
          We compare policies across a range of New Zealand insurers, then
          recommend the type and level of cover that your budget will actually
          sustain. Cover you cancel in two years is worth very little.
        </p>
        <ul style={{ fontSize: "13px", color: "#4b5563" }}>
          <li>Work out what you would want to happen if something went wrong</li>
          <li>Compare the wordings, the benefits and, more importantly, the exclusions</li>
          <li>Set the cover up, and help you claim on it later if it comes to that</li>
          <li>Review it when your circumstances change</li>
        </ul>
        <p style={{ fontSize: "12px", color: "#6b7280", marginTop: "8px" }}>
          Premiums are paid directly to the insurer. In most cases we are paid
          via commission from the insurer; if we charge a fee, we will agree
          this with you in advance.
        </p>
      </div>
    </section>
  );
}

export default Insurance;
